class ImgParallax {
  constructor(el, opt) {
    this.el = el;
    const elements = document.querySelectorAll("." + this.el);
    if (elements.length > 0) {
      this.event(elements);
    }
  }

  event(elements) {
    // batch() を使って複数の要素を一括で処理
    ScrollTrigger.batch(elements, {
      onEnter: batch => {
        batch.forEach((ele, index) => {
          const scrub = ele.dataset.scrub ? ele.dataset.scrub : 3;

          const wrapperHeight = ele.getBoundingClientRect().height;
          const imgHeight = ele.querySelector('img').getBoundingClientRect().height;
          const moveTop = Math.min(0, wrapperHeight - imgHeight); // 0以下にならないように調整

          gsap.to(ele.querySelector('img'), {
            y: moveTop,
            scrollTrigger: {
              trigger: ele, // 要素そのものを指定
              start: 'top bottom',
              end: 'bottom top',
              scrub: scrub,
            }
          });
        });
      },
      start: "top bottom", // トリガー位置を指定
      end: "bottom top",   // トリガー終了位置を指定
      scrub: true          // スクロール連動で動かす
    });
  }
}
